import React from "react";
var __jsx = React.createElement;
import { Then } from "@componentsShared/Conditional/Then";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import { Else } from "@componentsShared/Conditional/Else";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import useIsMobile from "@hooks/useIsMobile";
var UpgradeWarrantyModal = function UpgradeWarrantyModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    children = _ref.children;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    id: "contact-support-modal-drawer-overlay",
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    id: "contact-support-modal-drawer",
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6 max-h-screen"
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-drawer-close-button",
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), children)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    id: "contact-support-modal-dialog",
    className: "min-w-[600px] z-[10000] lg:min-w-[clamp(33.25rem,_-24.9038rem_+_90.8654cqi,_56.875rem)] p-6",
    haveClose: false,
    overlayClassName: "z-[10000]"
  }, /*#__PURE__*/React.createElement("div", {
    id: "contact-support-modal-dialog-close-button",
    className: "absolute left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F]"
  })), children)))));
};
export default UpgradeWarrantyModal;